/** Dữ liệu mẫu cho tab "Bộ phát triển" khi chạy `?mock=` hoặc chưa đăng nhập Keycloak thật (ADR-0113). */
import type { DanhMucBoKhoiTao } from '../modules/module-to-chuc/types';

export function danhMucBoKhoiTaoGia(): DanhMucBoKhoiTao {
  return {
    sdk_version: '0.2.0-beta.2',
    items: [
      {
        code: 'tri-thuc', name: 'Tri thức AI', vendor: 'FoxAI', version: '1.0.0',
        description: 'Kho tri thức theo phòng ban, phân quyền đến từng tệp, kiểm duyệt tài liệu và đồng bộ sang tìm kiếm của trợ lý AI.',
        permission_count: 20, route_count: 4, file: 'extend-tri-thuc.zip', size: 24_800, sha256: 'a1',
      },
      {
        code: 'ocr', name: 'Xử lý tài liệu', vendor: 'FoxAI', version: '1.4.0',
        description: 'Nhận dạng và trích xuất dữ liệu từ tài liệu.',
        permission_count: 11, route_count: 6, file: 'extend-ocr.zip', size: 23_600, sha256: 'a2',
      },
      {
        code: 'ekyc', name: 'Định danh eKYC', vendor: 'FoxAI', version: '1.0.0',
        description: 'Quy trình định danh khách hàng và xác thực đối tác.',
        permission_count: 9, route_count: 3, file: 'extend-ekyc.zip', size: 25_300, sha256: 'a3',
      },
    ],
  };
}
